import { absolutePath } from "../absolutePath";
import {
  paywalls,
  paywallsAffiliates,
  paywallsAffiliatesCommissions,
} from "./paywalls";

export interface SearchFnProps {
  params?: {
    page?: number;
    query?: string;
    [key: string]: any;
  };
}

export const search = {
  communityMembers: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("search/community_members", params),
    /** Multiple instances of filters - AND/OR */
    indexV2: ({ params = {} }: SearchFnProps) =>
      absolutePath("v2/search/community_members", params, {
        arrayFormat: "indices",
      }),
  },
  spaces: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("search/spaces", params),
  },
  communities: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("search/communities", params),
  },
  paywalls,
  paywallsAffiliates,
  paywallsAffiliatesCommissions,
  chatRooms: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("search/chat_rooms", params),
  },
  contacts: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("v2/search/contacts", params, {
        arrayFormat: "indices",
      }),
    indexV3: ({ params = {} }: SearchFnProps) =>
      absolutePath("v3/search/contacts", params, {
        arrayFormat: "indices",
      }),
  },
  chatRoomMessages: {
    index: ({
      params = {},
      chat_room_uuid,
    }: {
      params: SearchFnProps["params"];
      chat_room_uuid: string;
    }) =>
      absolutePath(
        `search/chat_rooms/${chat_room_uuid}/chat_room_messages`,
        params,
      ),
  },
  chatRoomCommunityMembers: {
    index: ({
      uuid,
      params = {},
    }: {
      uuid: string;
      params?: SearchFnProps["params"];
    }) =>
      absolutePath(
        `search/chat_room_community_members/${uuid}/community_members`,
        params,
      ),
  },
  communityInbox: {
    chats: ({ params = {} }: SearchFnProps) =>
      absolutePath("search/community_inbox/chats", params),
  },
};

export const searchV2 = {
  basic: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("search/community_members.json", params),
  },
  advanced: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("search/advanced_search", params),
  },
  count: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("search/advanced_search/count.json", params),
  },
  advancedCount: {
    index: ({ params = {} }: SearchFnProps) =>
      absolutePath("search/community_members.json", params),
  },
};
